import { apiErrorMessage } from "../helpers/apiErrorMessage";
import { createModule } from "saga-slice";
import { call, put } from "redux-saga/effects";
import promotionService from "../services/promotionService";

const initialState = {
    list: [],
    selectedPromotion: null,
    loading: false,
    loadingDetails: false,
    printing: false,
    error: null,
};

const promotionSlice = createModule({
    name: "promotions",
    initialState,

    reducers: {
        list: (state) => {
            state.loading = true;
            state.error = null;
        },

        getById: (state) => {
            state.loadingDetails = true;
            state.error = null;
        },

        create: (state) => {
            state.loading = true;
            state.error = null;
        },

        print: (state) => {
            state.printing = true;
            state.error = null;
        },

        fetchedData: (state, payload) => {
            state.loading = false;
            state.list = payload.body || [];
        },

        fetchedDetails: (state, payload) => {
            state.loadingDetails = false;
            state.selectedPromotion = payload.body;
        },

        finishFetching: (state) => {
            state.loading = false;
            state.loadingDetails = false;
            state.printing = false;
        },

        fetchError: (state, action) => {
            state.loading = false;
            state.loadingDetails = false;
            state.printing = false;
            state.error = apiErrorMessage(action);
        },

        clearSelectedPromotion: (state) => {
            state.selectedPromotion = null;
        },
    },

    sagas: (A) => ({
        *[A.list]() {
            try {
                const { data } = yield call(promotionService.list);
                yield put(A.fetchedData({ body: data }));
            } catch (error) {
                yield put(A.fetchError(error?.response?.data?.message || error.message));
            }
        },

        *[A.getById]({ payload }) {
            try {
                const { data } = yield call(promotionService.getById, payload.id);
                yield put(A.fetchedDetails({ body: data }));
                if (payload.onSuccess) {
                    yield call(payload.onSuccess, data);
                }
            } catch (error) {
                yield put(A.fetchError(error?.response?.data?.message || error.message));
                if (payload.onError) {
                    yield call(payload.onError, error);
                }
            }
        },

        *[A.create]({ payload }) {
            try {
                const { data } = yield call(promotionService.create, payload.data);
                yield put(A.finishFetching());
                if (payload.onSuccess) {
                    yield call(payload.onSuccess, data);
                }
            } catch (error) {
                yield put(A.fetchError(error?.response?.data?.message || error.message));
                if (payload.onError) {
                    yield call(payload.onError, error);
                }
            }
        },

        *[A.print]({ payload }) {
            try {
                const response = yield call(promotionService.print, payload.id);

                const blob = new Blob([response.data], { type: "application/pdf" });
                const fileURL = window.URL.createObjectURL(blob);
                window.open(fileURL, "_blank");

                yield put(A.finishFetching());

                if (payload.onSuccess) {
                    yield call(payload.onSuccess);
                }
            } catch (error) {
                yield put(A.fetchError(error?.response?.data?.message || error.message));
                if (payload.onError) {
                    yield call(payload.onError, error);
                }
            }
        },
    }),
});

export default promotionSlice;
export const promotionActions = promotionSlice.actions;